import analytics from '@utils/analytics';
import * as focusTrap from 'focus-trap';
import whatInput from 'what-input';
import BaseComponent from '../base/baseComponent';
export default class headerNavigation extends BaseComponent {
    constructor(element) {
        super(element);
        this.clickEvent = (e) => {
            const currentInput = whatInput.ask();
            if (currentInput === 'keyboard' || currentInput === 'touch' || document.body.classList.contains('keyboard-mode')) {
                e.preventDefault();
                const clickedLink = e.currentTarget;
                analytics.firstLevelClick(clickedLink.dataset.gtmEvent);
                const { trap } = this.menuTraps.find((trap) => trap.el === clickedLink);
                if (trap) {
                    if (clickedLink.getAttribute('aria-expanded') === 'true') {
                        trap.deactivate();
                    }
                    else {
                        trap.activate();
                    }
                }
            }
        };
        this.toggleFirstLevel = (el) => {
            this.EMIT(this.CUSTOM_MESSAGES.BODY.TOGGLE_OVERLAY, {});
            el.setAttribute('aria-expanded', el.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
            el.parentElement.classList.toggle(this.CLASSES.open);
        };
        this.enterEvent = (e) => {
            if (whatInput.ask() != 'touch') {
                const hoveredLi = e.currentTarget;
                const containerSubmenu = hoveredLi.lastElementChild.firstElementChild;
                const containerSubmenuHeight = containerSubmenu ? `${containerSubmenu.offsetHeight}px` : null;
                if (!this.isExpanded) {
                    this.$el.classList.add('no-transition');
                    setTimeout(() => {
                        this.$el.classList.remove('no-transition');
                    }, 300);
                    this.isExpanded = true;
                    this.menuWrapper.classList.add(this.CLASSES.expanded);
                    this.EMIT(this.CUSTOM_MESSAGES.BODY.ON_OVERLAY, {});
                    if (containerSubmenuHeight) {
                        this.allSubmenu.forEach((current) => {
                            current.style.height = containerSubmenuHeight;
                        });
                    }
                    hoveredLi.classList.add(this.CLASSES.open);
                    hoveredLi.firstElementChild.setAttribute('aria-expanded', 'true');
                }
                else {
                    const lastOpen = this.firstLevelLi.find((li) => li.classList.contains(this.CLASSES.open));
                    const lastMenuWrapper = lastOpen.lastElementChild;
                    lastMenuWrapper.style.transitionProperty = 'none';
                    // del nuovo li che devo aprire animo solo l'altezza
                    const currentMenuWrapper = hoveredLi.lastElementChild;
                    currentMenuWrapper.style.transitionProperty = 'height';
                    lastOpen.firstElementChild.setAttribute('aria-expanded', 'false');
                    hoveredLi.firstElementChild.setAttribute('aria-expanded', 'true');
                    // e alla fine tolgo l'open da quello precedente
                    lastOpen.classList.remove(this.CLASSES.open);
                    hoveredLi.classList.add(this.CLASSES.open);
                    // metto la nuova altezza
                    if (containerSubmenuHeight) {
                        this.allSubmenu.forEach((current) => {
                            current.style.height = containerSubmenuHeight;
                        });
                    }
                    // dopo 300ms tolgo la transition only height
                    setTimeout(() => {
                        currentMenuWrapper.style.removeProperty('transition-property');
                        lastMenuWrapper.style.removeProperty('transition-property');
                    }, 300);
                }
            }
        };
        this.leaveEvent = (e) => {
            var _a, _b, _c;
            if (whatInput.ask() != 'touch') {
                const matchFirst = (_a = e.relatedTarget) === null || _a === void 0 ? void 0 : _a.matches(this.SELECTORS.firstLevelLinks);
                if (!e.relatedTarget || !this.menuWrapper.contains(e.relatedTarget) || !matchFirst) {
                    this.$el.classList.add('delay-transition');
                    setTimeout(() => {
                        this.$el.classList.remove('delay-transition');
                    }, 300);
                    this.isExpanded = false;
                    this.menuWrapper.classList.remove(this.CLASSES.expanded);
                    this.EMIT(this.CUSTOM_MESSAGES.BODY.OFF_OVERLAY, {});
                    // resetto le altezza in uscita
                    this.allSubmenu.forEach((current) => {
                        current.style.height = `${current.firstElementChild.offsetHeight}px`;
                    });
                    const isCloseButton = (_b = e.currentTarget) === null || _b === void 0 ? void 0 : _b.matches(this.SELECTORS.closeButton);
                    let parentMenuItem = null;
                    if (isCloseButton) {
                        parentMenuItem = e.currentTarget.closest(this.SELECTORS.firstLevelLi);
                    }
                    const hoveredLi = parentMenuItem || e.currentTarget;
                    hoveredLi.classList.remove(this.CLASSES.open);
                    (_c = hoveredLi.querySelector(this.SELECTORS.firstLevelLinks)) === null || _c === void 0 ? void 0 : _c.setAttribute('aria-expanded', 'false');
                }
            }
        };
        this.closeButtonClick = (e, lastOpen) => {
            const firstLevelLink = lastOpen.querySelector('a' + this.SELECTORS.firstLevelLinks);
            const { trap } = this.menuTraps.find((trap) => trap.el === firstLevelLink);
            if (trap) {
                trap.deactivate();
            }
        };
        this.mobileClick = (e) => {
            var _a;
            //check if is voice has sub menu
            const currentHeading = e.currentTarget;
            if (Boolean(currentHeading.getAttribute('aria-haspopup'))) {
                //then prevent link navigation
                e.preventDefault();
            }
            this.accountWrapper.forEach((el) => {
                el.classList.add(this.CLASSES.hide);
            });
            if (this.nav.classList.contains(this.CLASSES.open)) {
                this.menuTitle.classList.add(this.CLASSES.show);
            }
            if (currentHeading.matches(this.SELECTORS.firstLevelLinks)) {
                this.firstLevelClicked = currentHeading;
                const url = currentHeading.getAttribute('data-href') || currentHeading.getAttribute('href') || 'javascript:;';
                this.titleText.setAttribute('href', url);
                this.titleText.innerHTML = currentHeading.innerHTML;
                if (this.menuOpen && this.nav.classList.contains(this.CLASSES.open)) {
                    currentHeading.setAttribute('aria-expanded', 'true');
                }
                else {
                    currentHeading.setAttribute('aria-expanded', 'false');
                }
                if (this.nav.classList.contains(this.CLASSES.open)) {
                    this.nav.classList.add(this.CLASSES.firstLevel);
                    this.menuBack.focus();
                    const accordionList = document.querySelectorAll('button.submenu-heading');
                    accordionList === null || accordionList === void 0 ? void 0 : accordionList.forEach((el) => {
                        const panelId = el === null || el === void 0 ? void 0 : el.getAttribute('aria-controls');
                        const subcategoriesList = document.getElementById(panelId);
                        if (!subcategoriesList) {
                            return;
                        }
                        subcategoriesList.parentElement.setAttribute('aria-hidden', 'true');
                        const subcategoryListItem = subcategoriesList.querySelectorAll('.submenu-item');
                        subcategoryListItem.forEach((el) => {
                            el.setAttribute('tabindex', '-1');
                        });
                    });
                }
                if (this.menuWrapper) {
                    this.menuWrapper.scrollTop = 0;
                }
                analytics.firstLevelClick(currentHeading.dataset.gtmEvent);
            }
            else if (currentHeading.matches(this.SELECTORS.secondLevelLinks)) {
                if (this.nav.classList.contains(this.CLASSES.open) && this.nav.classList.contains(this.CLASSES.firstLevel)) {
                    this.nav.classList.add(this.CLASSES.secondLevel);
                }
                // toggle accordion second level
                const accordionList = document.querySelectorAll('button.submenu-heading');
                accordionList === null || accordionList === void 0 ? void 0 : accordionList.forEach((el) => {
                    const panelId = el === null || el === void 0 ? void 0 : el.getAttribute('aria-controls');
                    const subcategoriesList = document.getElementById(panelId);
                    if (!subcategoriesList) {
                        return;
                    }
                    subcategoriesList.parentElement.setAttribute('aria-hidden', 'false');
                    const subcategoryListItem = subcategoriesList.querySelectorAll('.submenu-item');
                    subcategoryListItem.forEach((el) => {
                        el.setAttribute('tabindex', '0');
                    });
                    const isClosing = currentHeading.getAttribute('aria-expanded') === 'true';
                    if (el != currentHeading || isClosing) {
                        subcategoriesList.parentElement.style.height = '';
                        el === null || el === void 0 ? void 0 : el.setAttribute('aria-expanded', 'false');
                        setTimeout(() => {
                            subcategoriesList.parentElement.setAttribute('aria-hidden', 'true');
                            const subcategoryListItem = subcategoriesList.querySelectorAll('.submenu-item');
                            subcategoryListItem.forEach((el) => {
                                el.setAttribute('tabindex', '-1');
                            });
                        }, 500);
                    }
                    else {
                        this.secondLevelClicked = currentHeading;
                        let listHeight = subcategoriesList === null || subcategoriesList === void 0 ? void 0 : subcategoriesList.offsetHeight;
                        subcategoriesList.parentElement.style.height = listHeight + 'px';
                        subcategoriesList.parentElement.setAttribute('aria-hidden', 'false');
                        const subcategoryListItem = subcategoriesList.querySelectorAll('.submenu-item');
                        subcategoryListItem.forEach((el) => {
                            el.setAttribute('tabindex', '0');
                        });
                        currentHeading.setAttribute('aria-expanded', 'true');
                    }
                });
                analytics.secondLevelClick((_a = this.firstLevelClicked) === null || _a === void 0 ? void 0 : _a.dataset.gtmEvent, currentHeading === null || currentHeading === void 0 ? void 0 : currentHeading.dataset.gtmEvent);
            }
        };
        this.closeMobile = () => {
            document.body.classList.remove('is-fixed');
            window.scroll(0, this.scrollTop);
            document.documentElement.style.scrollBehavior = 'smooth';
            visualViewport.onresize = null;
            this.menuOpen.setAttribute('aria-expanded', 'false');
            this.nav.classList.remove(this.CLASSES.open);
            document.body.classList.remove(this.CLASSES.noOverflow);
            this.menuTitle.classList.remove(this.CLASSES.show);
            this.menuOpen.focus();
            // resetto lo stato iniziale del menu
            setTimeout(() => {
                this.accountWrapper.forEach((el) => {
                    el.classList.remove(this.CLASSES.hide);
                });
                this.submenuToggler.forEach((el) => {
                    el.setAttribute('aria-expanded', 'false');
                });
                this.nav.classList.remove(this.CLASSES.firstLevel);
                this.nav.classList.remove(this.CLASSES.secondLevel);
                this.firstLevelClicked = null;
                this.secondLevelClicked = null;
            }, 300);
            if (this.secondLevelClicked && this.firstLevelClicked) {
                analytics.closeMenuFromThirdLevel(this.firstLevelClicked.dataset.gtmEvent, this.secondLevelClicked.dataset.gtmEvent);
            }
            else if (this.firstLevelClicked) {
                analytics.closeMenuFromSecondLevel(this.firstLevelClicked.dataset.gtmEvent);
            }
            else {
                analytics.closeMenuFromFirstLevel();
            }
        };
        this.mobileBack = () => {
            this.accountWrapper.forEach((el) => {
                el.classList.remove(this.CLASSES.hide);
            });
            this.menuTitle.classList.remove(this.CLASSES.show);
            // back from 2nd level
            if (this.secondLevelClicked && this.firstLevelClicked) {
                if (this.secondLevelClicked.getAttribute('aria-expanded') == 'true') {
                    const panelId = this.secondLevelClicked.getAttribute('aria-controls') || '';
                    const subcategoriesList = document.getElementById(panelId);
                    if (subcategoriesList) {
                        subcategoriesList.parentElement.style.height = '';
                        subcategoriesList.parentElement.setAttribute('aria-hidden', 'true');
                        const subcategoryListItem = subcategoriesList.querySelectorAll('.submenu-item');
                        subcategoryListItem.forEach((el) => {
                            el.setAttribute('tabindex', '-1');
                        });
                        this.secondLevelClicked.setAttribute('aria-expanded', 'false');
                    }
                }
                this.nav.classList.remove(this.CLASSES.secondLevel);
                analytics.backFromThirdLevel(this.firstLevelClicked.dataset.gtmEvent, this.secondLevelClicked.dataset.gtmEvent);
                this.secondLevelClicked = null;
            }
            // back from 1st level
            if (this.firstLevelClicked) {
                this.nav.classList.remove(this.CLASSES.firstLevel);
                analytics.backFromSecondLevel(this.firstLevelClicked.dataset.gtmEvent);
                this.firstLevelClicked.setAttribute('aria-expanded', 'false');
                setTimeout(() => {
                    this.firstLevelClicked.focus();
                    this.firstLevelClicked = null;
                }, 100);
            }
        };
        // this.mobileOnlyListerners = false;
        this.scrollTop = 0;
        this.isDesktop = window.isDesktop();
        this.desktopNavigation();
        this.mobileNavigation();
        this.isLandscape = window.innerWidth > window.mqObj.md;
    }
    get Messages() {
        return {
            [this.CUSTOM_MESSAGES.BREAKPOINTER.BREAKPOINT_CHANGE]: this.onBreakpointChange,
        };
    }
    get SELECTORS() {
        return {
            firstLevelLinks: '.menu-heading',
            secondLevelLinks: '.submenu-heading:not(.third-level)',
            thirdLevelLinks: '.submenu-heading.third-level',
            firstLevelLi: '.menu-item',
            menuWrapper: '.menu-wrapper',
            navigation: '.navigation',
            menuOpen: '[data-menu-open]',
            menuClose: '[data-menu-close]',
            menuBack: '[data-menu-back]',
            submenuToggler: '.menu-wrapper [aria-expanded]',
            account: '.account-wrapper',
            menuTitle: '.menu-title',
            mobileDialog: '#mainnav',
            wrapperSubmenu: '.wrapper-submenu',
            closeButton: '.menu-button-close',
        };
    }
    get CLASSES() {
        return {
            open: 'open',
            // overlay: 'overlay',
            show: 'show',
            hide: 'hide',
            expanded: 'expanded',
            noOverflow: 'no-overflow',
            firstLevel: 'first-level',
            secondLevel: 'second-level',
        };
    }
    desktopNavigation() {
        if (this.isDesktop) {
            this.firstLevelLinks = this.$el.querySelectorAll('a' + this.SELECTORS.firstLevelLinks);
            if (!this.firstLevelLi) {
                this.firstLevelLi = [];
            }
            if (!this.menuTraps) {
                this.menuTraps = [];
            }
            if (!this.menuWrapper) {
                this.menuWrapper = this.$el.querySelector(this.SELECTORS.menuWrapper);
            }
            if (!this.allSubmenu) {
                this.allSubmenu = document.querySelectorAll(this.SELECTORS.wrapperSubmenu);
            }
            this.allSubmenu.forEach((current) => {
                current.style.height = `${current.firstElementChild.offsetHeight}px`;
            });
            this.menuWrapper.style.removeProperty('height');
            if (this.firstLevelLinks.length > 0) {
                // gestione navigazione da tastiera
                this.firstLevelLinks.forEach((el) => {
                    this.firstLevelLi.push(el.parentElement);
                    // init traps
                    const trap = focusTrap.createFocusTrap(el.nextElementSibling, {
                        onDeactivate: () => {
                            this.toggleFirstLevel(el);
                        },
                        onActivate: () => this.toggleFirstLevel(el),
                        clickOutsideDeactivates: (e) => {
                            if (e.target === el || (e.target.tagName.toLowerCase() === 'span' && e.target.parentElement === el)) {
                                return false;
                            }
                            else {
                                return true;
                            }
                        },
                        fallbackFocus: () => {
                            return el.nextElementSibling.querySelector('a');
                        },
                    });
                    this.menuTraps.push({ el, trap });
                    el.addEventListener('click', this.clickEvent);
                });
                // gestione mouse enter/leave
                this.firstLevelLi.forEach((el) => {
                    el.addEventListener('mouseenter', this.enterEvent);
                    el.addEventListener('mouseleave', this.leaveEvent);
                    const closeButton = el.querySelector(this.SELECTORS.closeButton);
                    if (closeButton) {
                        closeButton.addEventListener('click', (e) => this.closeButtonClick(e, el));
                    }
                });
            }
        }
        else {
            // Cleanup listeners
            if (this.firstLevelLinks) {
                this.firstLevelLinks.forEach((el) => {
                    el.removeEventListener('click', this.clickEvent);
                });
                this.firstLevelLi.forEach((el) => {
                    el.removeEventListener('mouseenter', this.enterEvent);
                    el.removeEventListener('mouseleave', this.leaveEvent);
                });
                this.allSubmenu.forEach((current) => {
                    current.style.removeProperty('height');
                });
            }
        }
    }
    mobileNavigation() {
        if (!this.isDesktop) {
            if (!this.nav) {
                this.nav = this.$el.querySelector(this.SELECTORS.navigation);
            }
            if (!this.menuOpen) {
                this.menuOpen = this.$el.querySelector(this.SELECTORS.menuOpen);
            }
            if (!this.menuClose) {
                this.menuClose = this.$el.querySelector(this.SELECTORS.menuClose);
            }
            if (!this.submenuToggler) {
                this.submenuToggler = this.$el.querySelectorAll(this.SELECTORS.submenuToggler);
            }
            if (!this.mobileDialog) {
                this.mobileDialog = this.$el.querySelector(this.SELECTORS.mobileDialog);
                this.mobileDialog.setAttribute('role', 'dialog');
            }
            this.mobileTrap = focusTrap.createFocusTrap(['.menu-wrapper'], {
                onDeactivate: this.closeMobile,
                fallbackFocus: '.menu-close',
                initialFocus: '.menu-close',
                clickOutsideDeactivates: true,
            });
            //inizializzo il menu con tutti i submenus chiusi
            this.submenuToggler.forEach((el) => {
                el.setAttribute('aria-expanded', 'false');
            });
            this.firstLevelLinks = this.$el.querySelectorAll('a' + this.SELECTORS.firstLevelLinks);
            this.firstLevelLinks.forEach((el) => {
                var _a, _b;
                el.setAttribute('aria-haspopup', 'true');
                (_a = el.nextElementSibling) === null || _a === void 0 ? void 0 : _a.removeAttribute('role');
                (_b = el.nextElementSibling) === null || _b === void 0 ? void 0 : _b.removeAttribute('aria-labelledby');
            });
            if (!this.accountWrapper) {
                this.accountWrapper = this.$el.querySelectorAll(this.SELECTORS.account);
            }
            if (!this.menuTitle) {
                this.menuTitle = this.$el.querySelector(this.SELECTORS.menuTitle);
            }
            if (!this.titleText) {
                this.titleText = this.menuTitle.querySelector('a');
            }
            if (!this.menuBack) {
                this.menuBack = this.$el.querySelector(this.SELECTORS.menuBack);
            }
            if (!this.headings) {
                this.headings = this.$el.querySelectorAll(`${this.SELECTORS.firstLevelLinks}, ${this.SELECTORS.secondLevelLinks}`);
            }
            this.headings.forEach((el) => {
                el.addEventListener('click', this.mobileClick);
            });
            // questi listeners devono essere aggiunti 1 volta sola
            if (!this.mobileOnlyListerners) {
                this.mobileOnlyListerners = true;
                this.titleText.addEventListener('click', (e) => {
                    var _a, _b;
                    const firstSectionClicked = (_a = this.firstLevelClicked) === null || _a === void 0 ? void 0 : _a.dataset.gtmEvent;
                    const secondSectionClicked = (_b = this.secondLevelClicked) === null || _b === void 0 ? void 0 : _b.dataset.gtmEvent;
                    // we assume that is an FLP (but it could not be)
                    analytics.thirdLevelClick(firstSectionClicked, secondSectionClicked, 'flp');
                });
                this.menuBack.addEventListener('click', this.mobileBack);
                this.menuOpen.addEventListener('click', () => {
                    if (!this.isLandscape) {
                        document.documentElement.style.scrollBehavior = 'auto';
                        this.scrollTop = window.scrollY;
                        window.scroll(0, this.scrollTop);
                    }
                    this.menuOpen.setAttribute('aria-expanded', 'true');
                    this.mobileDialog.setAttribute('aria-modal', 'true');
                    this.mobileDialog.setAttribute('tabindex', '-1');
                    this.nav.classList.add(this.CLASSES.open);
                    // this.$el.classList.add(this.CLASSES.overlay);
                    this.mobileTrap.activate();
                    window.sprChat && window.sprChat('disable');
                    analytics.header('menu');
                    if (!this.menuWrapper) {
                        this.menuWrapper = this.$el.querySelector(this.SELECTORS.menuWrapper);
                    }
                    if (this.menuWrapper && !this.isDesktop) {
                        visualViewport.onresize = () => {
                            if (!this.isDesktop) {
                                this.menuWrapper.style.height = `${visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.height}px`;
                            }
                        };
                        this.menuWrapper.style.height = `${visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.height}px`;
                    }
                    setTimeout(() => {
                        document.body.classList.add(this.CLASSES.noOverflow);
                    }, 250);
                });
                this.menuClose.addEventListener('click', () => {
                    this.mobileTrap.deactivate();
                    window.sprChat && window.sprChat('enable');
                });
            }
        }
        else {
            // Cleanup listeners
            if (this.nav) {
                this.nav.classList.remove(this.CLASSES.open);
                this.nav.classList.remove(this.CLASSES.firstLevel);
                this.nav.classList.remove(this.CLASSES.secondLevel);
                this.menuTitle.classList.remove(this.CLASSES.show);
            }
            if (this.mobileDialog) {
                this.mobileDialog.removeAttribute('role');
            }
            if (!this.firstLevelLinks) {
                this.firstLevelLinks = this.$el.querySelectorAll(this.SELECTORS.firstLevelLinks);
            }
            this.firstLevelLinks.forEach((el) => {
                var _a, _b;
                el.setAttribute('aria-haspopup', 'dialog');
                (_a = el.nextElementSibling) === null || _a === void 0 ? void 0 : _a.setAttribute('role', 'dialog');
                (_b = el.nextElementSibling) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-labelledby', `${el.nextElementSibling.id}-title`);
            });
            document.body.classList.remove(this.CLASSES.noOverflow);
            if (this.headings) {
                this.headings.forEach((el) => {
                    el.removeEventListener('click', this.mobileClick);
                });
            }
            if (this.submenuToggler) {
                this.submenuToggler.forEach((el) => {
                    el.setAttribute('aria-expanded', 'false');
                });
            }
        }
    }
    onBreakpointChange(br) {
        // this.$log(br);
        if (br.value > window.mqObj['sm']) {
            this.isLandscape = true;
        }
        if (br.value >= window.mqObj['md'] && !this.isDesktop) {
            this.isDesktop = true;
            this.desktopNavigation();
            this.mobileNavigation();
            this.menuWrapper.style.removeProperty('height');
        }
        else if (br.value < window.mqObj['md'] && this.isDesktop) {
            this.isDesktop = false;
            this.desktopNavigation();
            this.mobileNavigation();
        }
    }
}
